/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const MoneyStack56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none">
            <path fill={vars.bdlBoxBlue10} d="M18 4a6 6 0 110 12 6 6 0 010-12zm26 32a8 8 0 110 16 8 8 0 010-16z" />
            <path
                fill={vars.white}
                d="M46 14c2.21 0 4 1.79 4 4v14c0 2.21-1.79 4-4 4H18c-2.21 0-4-1.79-4-4V18c0-2.21 1.79-4 4-4h28z"
            />
            <path
                fill={vars.bdlBoxBlue}
                d="M46 12a6 6 0 016 6v14a6 6 0 01-4.262 5.744l.005-.001a6.015 6.015 0 01-3.808 3.938l-.192.062a6.003 6.003 0 01-5.49 4.252L38 46H10a6 6 0 01-5.996-5.775L4 40V26a6.002 6.002 0 014.257-5.743l.062-.192a6.015 6.015 0 013.938-3.808l.063-.194A6.002 6.002 0 0118 12zM8 22v.535a3.998 3.998 0 00-1.993 3.233L6 26v14a4 4 0 003.8 3.995L10 44h28c1.48 0 2.773-.804 3.465-2H42 14a6 6 0 01-5.996-5.775L8 36V22zm10 16a6 6 0 01-6-6V18c0-.049 0-.097.002-.145L12 18v.535a3.998 3.998 0 00-1.993 3.233L10 22v14a4 4 0 003.8 3.995L14 40h28c1.48 0 2.773-.804 3.465-2zm28-24H18c-2.21 0-4 1.79-4 4v14c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V18c0-2.21-1.79-4-4-4z"
            />
            <path
                fill={vars.bdlBoxBlue}
                d="M42 16H14a6 6 0 00-6 6v14a6 6 0 006 6h28a6 6 0 006-6V22a6 6 0 00-6-6zm0 2c2.21 0 4 1.79 4 4v14c0 2.21-1.79 4-4 4H14c-2.21 0-4-1.79-4-4V22c0-2.21 1.79-4 4-4h28z"
            />
            <path
                fill={vars.white}
                d="M46 14c2.21 0 4 1.79 4 4v14c0 2.21-1.79 4-4 4H18c-2.21 0-4-1.79-4-4V18c0-2.21 1.79-4 4-4h28z"
            />
            <path
                fill={vars.bdlBoxBlue}
                d="M46 12a6 6 0 016 6v14a6 6 0 01-6 6H18a6 6 0 01-6-6V18a6 6 0 016-6zm0 2H18c-2.21 0-4 1.79-4 4v14c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V18c0-2.21-1.79-4-4-4zm-.5 17a.5.5 0 010 1h-3a.5.5 0 010-1h3zm-24 0a.5.5 0 010 1h-3a.5.5 0 010-1h3zM32 20a5 5 0 11-.001 10.001A5 5 0 0132 20zm0 1c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-10.5-3a.5.5 0 010 1h-3a.5.5 0 010-1h3zm24 0a.5.5 0 010 1h-3a.5.5 0 010-1h3z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                d="M7.997 22.538v13.464l.004.225a6 6 0 005.771 5.771l.225.004h27.465a3.998 3.998 0 01-3.465 2h-28c-2.21 0-4-1.79-4-4v-14c0-1.48.804-2.773 2-3.464zM12 18.54V32l.003.195.004.095.01.168a6 6 0 005.758 5.543l.225.004h27.465a3.998 3.998 0 01-3.465 2H14a4 4 0 01-4-4v-14c0-1.48.805-2.773 2-3.465zM32 21c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z"
            />
        </g>
    </AccessibleSVG>
);

export default MoneyStack56;
